import { useEffect } from "react";
import { onUpdate } from "src/hooks/onUpdate";
import useCodeMirror from "src/hooks/useCodeMirror";
import { onCursorUpdate } from "./onCursorUpdate";

interface CodeEditorProps {
  value: string;
  onChange: (value: string) => void;
  onChangeCursor: (value: number) => void;
}

export function useCodeEditor({
  value,
  onChange,
  onChangeCursor,
}: CodeEditorProps): React.RefObject<HTMLDivElement | null> {
  const { ref, view } = useCodeMirror([
    onUpdate(onChange),
    onCursorUpdate(onChangeCursor),
  ]);

  useEffect(() => {
    if (view) {
      const editorValue = view.state.doc.toString();

      if (value !== editorValue) {
        view.dispatch({
          changes: {
            from: 0,
            to: editorValue.length,
            insert: value || "",
          },
        });
      }
    }
  }, [value, view]);

  return ref;
}
